export default __webpack_public_path__ + "styles/UserPermissions.747ca929a9250912be888de70adc9c64.css";